import { createSelector } from 'reselect';
import { getFolderIsLoading } from '../common/selector';
import { folderPresenter } from '../common/folderPresenter';
import { FolderEditView } from './view/FolderEditView';
import {
  getFolders,
  getFoldersLaoding,
} from '../../myArmyList/common/selector';
import { FolderView } from '../../myArmyList/common/ArmyListView';

export const FolderEditPresenter = createSelector(
  [folderPresenter, getFolderIsLoading, getFoldersLaoding, getFolders],
  (folder, folderLoading, foldersLoading, folders): FolderEditView => {
    return new FolderEditView({
      folder: folder,
      folders: folders
        .filter((item) => item.id != folder.parentId && item.id != folder.id)
        .map(
          (item) =>
            ({
              id: item.id,
              name: item.name,
              parentId: item.parentId,
              isShare: item.isShare,
              parentName: null,
            }) satisfies FolderView as FolderView,
        ),
      isLoading: folderLoading || foldersLoading,
      canSubmit: !(folderLoading || foldersLoading),
    });
  },
);
